import { render, staticRenderFns } from "./SizeVariants.vue?vue&type=template&id=a6bdf16a&"
import script from "./SizeVariants.vue?vue&type=script&lang=js&"
export * from "./SizeVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports